/**
 * Single matched item returned by GET /api/qc-checklist-templates/match.
 * Backend stores only title/hint; the inspector-side key is generated client-side.
 */
export interface QCChecklistTemplateMatchedItem {
    readonly title: string;
    readonly hint: string | null;
}
